import { BiddingTaskTypes } from 'store/modules/bidding_store/types';

export interface TaskStateView {
  label: string;
  badge: string;
}

type TaskStateSource = Pick<BiddingTaskTypes, 'state' | 'status' | 'finished_at'>;

export const taskStateOf = (task: TaskStateSource): TaskStateView => {
  if (task.finished_at || task.status === 'done' || task.state === 'done') {
    return { label: 'Concluída', badge: 'success' };
  }
  if (task.state === 'late') return { label: 'Atrasada', badge: 'danger' };
  if (task.state === 'today') return { label: 'Hoje', badge: 'warning' };
  return { label: 'Futuro', badge: 'info' };
};
